// Import the functions you need from the SDKs you need
import { initializeApp } from 'firebase/app';
import { getDatabase, ref, onValue, push, onDisconnect, set, update } from 'firebase/database';
import { initializeFirestore, collection, addDoc, Timestamp, onSnapshot } from 'firebase/firestore';
import { getAnalytics } from 'firebase/analytics';
import state from '../services/store';

const firebaseConfig = {
  apiKey: 'AIzaSyAi7ENmc5XHGdMOQa1Nl2f8W1gHoNQzzU4',
  authDomain: 'kindness-minute.firebaseapp.com',
  databaseURL: 'https://kindness-minute-default-rtdb.europe-west1.firebasedatabase.app',
  projectId: 'kindness-minute',
  storageBucket: 'kindness-minute.appspot.com',
  messagingSenderId: '212155753798',
  appId: '1:212155753798:web:e3b7b940432a8d4d013147',
  measurementId: 'G-11JCB80K03',
};

const app = initializeApp(firebaseConfig);

const realtimeDB = getDatabase(app);
const firestoreDB = initializeFirestore(app, { experimentalAutoDetectLongPolling: true, ignoreUndefinedProperties: true });

class FirebaseController {
  private myConnectionsRef;
  private presenceRef;
  private myConnection;
  private worldMessages;

  async init(lon, lat) {

    getAnalytics(app);

    this.myConnectionsRef = ref(realtimeDB, 'presence');
    this.presenceRef = ref(realtimeDB, '.info/connected');
    this.worldMessages = collection(firestoreDB, 'world-messages');

    this.initPresence(lon, lat);
    this.initWorldMessages();
  }

  initPresence(lon, lat) {
    onValue(this.presenceRef, snap => {
      if (snap.val() === true) {
        this.myConnection = push(this.myConnectionsRef);
        onDisconnect(this.myConnection).remove();
        set(this.myConnection, { location: { lon: lon, lat: lat } });
      }
    });

    onValue(this.myConnectionsRef, snap => {
      state.onlineCount = snap.size;
      state.presenceList = snap.val();
    });
  }

  setMyEmoji(index) {
    update(this.myConnection, { emojiIndex: index });
  }

  async initWorldMessages() {
    await onSnapshot(this.worldMessages, querySnapshot => {
      const worldMessages = [];
      querySnapshot.forEach(doc => {
        worldMessages.push(doc.data());
        // console.log(doc.data());
      });
      state.worldMessages = worldMessages;
    });
  }

  async sendMessageToTheWorld(message, location, emojiIndex) {
    // Add a new document with a generated id.
    const docRef = await addDoc(collection(firestoreDB, 'world-messages'), {
      message: message,
      location: location,
      timestamp: Timestamp.fromDate(new Date()),
      emojiIndex: emojiIndex,
    });
    // console.log('Document written with ID: ', docRef.id);
  }
}

export const FirebaseService = new FirebaseController();
